"use strict";
export const ShopsMock = (mock) => {
  mock.onGet("/api/v7/groups/shop_list").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "shop.model",
            "shop_guid": "shop_05ebfb41792a48a488e74668d23b5dcf",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "AMAZON",
            "name": "\u8FC1\u79FB\u6765\u7684\u6CD5\u56FD\u7AD9",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
            "team_auth_count": 1,
            "last_login_name": null,
            "last_login_time": null,
            "ebusiness_platform_guid": "ebusiness_platform_9237d1aff74d48ae862890e13da3c173",
            "users": {
              "model": "data.set",
              "datas": [
                {
                  "model": "shop.user",
                  "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                  "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                  "account": "136720214790079",
                  "user_no": "79"
                }
              ],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_390bbdcc4205461784627f15a3d8ac4b",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "BLIBLI",
            "name": "blibli",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/blibli_small.png",
            "team_auth_count": 0,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 1620634535318,
            "ebusiness_platform_guid": "ebusiness_platform_49c90dae0ff84638a2a83b38919516d1",
            "users": {
              "model": "data.set",
              "datas": [],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_4e14602ba9874044ad95f597f889f353",
            "vd_guid": "virtual_desktop_6b8e757aafa745958cb16982527e4ae3",
            "ebusiness_type": "YAHOO",
            "name": "test",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_BIND_IP"
              ]
            },
            "ip": "127.0.0.1\u81EA\u914D\u4EE3\u7406(\u81EA\u5EFA\u4EE3\u7406IP)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/yahoo_small.png",
            "team_auth_count": 0,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 162028131e4,
            "ebusiness_platform_guid": "ebusiness_platform_43360e6ed4904a7cbce6723d03236902",
            "users": {
              "model": "data.set",
              "datas": [],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_50371ca13914475bba244d0017b65492",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "SHOPIFY",
            "name": "qweqwe",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/shopify_small.png",
            "team_auth_count": 1,
            "last_login_name": null,
            "last_login_time": null,
            "ebusiness_platform_guid": "ebusiness_platform_9e68aa6cd16d42f2a9f095624268592a",
            "users": {
              "model": "data.set",
              "datas": [
                {
                  "model": "shop.user",
                  "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                  "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                  "account": "136720214790079",
                  "user_no": "79"
                }
              ],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_503f5626ed344f6fa94ed169e7c2045b",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "AMAZON",
            "name": "\u597D\u51E0\u4E2Av",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
            "team_auth_count": 1,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 1620267825e3,
            "ebusiness_platform_guid": "ebusiness_platform_e12a51f687f5427a9a6436c878058f2b",
            "users": {
              "model": "data.set",
              "datas": [
                {
                  "model": "shop.user",
                  "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                  "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                  "account": "136720214790079",
                  "user_no": "79"
                }
              ],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_638f4a0f5d174716be0f2b08bd085864",
            "vd_guid": "virtual_desktop_0a8a159bb75c402c81c84bc8ab9ded7f",
            "ebusiness_type": "AMAZON",
            "name": "\u9ED8\u8BA4\u5E97\u94FA",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "OUTLANDS"
              ]
            },
            "ip": "47.253.58.117\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
            "team_auth_count": 0,
            "last_login_name": null,
            "last_login_time": null,
            "ebusiness_platform_guid": "ebusiness_platform_1a811442121540b898c4432a9413338d",
            "users": {
              "model": "data.set",
              "datas": [],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_7ec7bcc616ea4135a4c13196e53c3c63",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "FBA",
            "name": "5651514.0",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/fba_small.png",
            "team_auth_count": 1,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 1620268221e3,
            "ebusiness_platform_guid": "ebusiness_platform_7e460050312b4ef285c8e2e9ebc868be",
            "users": {
              "model": "data.set",
              "datas": [
                {
                  "model": "shop.user",
                  "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                  "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                  "account": "136720214790079",
                  "user_no": "79"
                }
              ],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_7ecfba9573b0445c99615459054e168a",
            "vd_guid": "virtual_desktop_6b8e757aafa745958cb16982527e4ae3",
            "ebusiness_type": "AMAZON",
            "name": "\u9ED8\u8BA4\u5E97\u94FA",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_BIND_IP"
              ]
            },
            "ip": "127.0.0.1\u81EA\u914D\u4EE3\u7406(\u81EA\u5EFA\u4EE3\u7406IP)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
            "team_auth_count": 0,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 162037884e4,
            "ebusiness_platform_guid": "ebusiness_platform_1a811442121540b898c4432a9413338d",
            "users": {
              "model": "data.set",
              "datas": [],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_83c2458ac34c44bca2649a8318ac7cb1",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "AMAZON",
            "name": "6154564.0",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
            "team_auth_count": 0,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 1620289661e3,
            "ebusiness_platform_guid": "ebusiness_platform_1a811442121540b898c4432a9413338d",
            "users": {
              "model": "data.set",
              "datas": [],
              "total": 5
            },
            "status": "active"
          },
          {
            "model": "shop.model",
            "shop_guid": "shop_a7d938b54c1b428c975c6d826f96e52a",
            "vd_guid": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
            "ebusiness_type": "QQ",
            "name": "exmail",
            "marks": {
              "model": "tags",
              "tags": [
                "IS_ADMIN",
                "REMOTE",
                "CAN_CREATE_ENV_SETTING"
              ]
            },
            "ip": "39.101.176.71\u5F20\u5BB6\u53E3(\u963F\u91CC)",
            "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/qq_small.png",
            "team_auth_count": 1,
            "last_login_name": "\u7BA1\u7406\u5458",
            "last_login_time": 1619314042e3,
            "ebusiness_platform_guid": "ebusiness_platform_88f0978110a32739fbd6ba5c90e26ec5",
            "users": {
              "model": "data.set",
              "datas": [
                {
                  "model": "shop.user",
                  "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                  "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                  "account": "136720214790079",
                  "user_no": "79"
                }
              ],
              "total": 5
            },
            "status": "active"
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 17,
        "size": 10
      }
    };
    return [200, response];
  });
  mock.onGet("v7/groups/shop_list").reply((config) => {
    let response = {
      "model": "data.set",
      "datas": [
        {
          "model": "group",
          "id": "shopgroup_system_all",
          "name": "\u5168\u90E8",
          "type": "system",
          "source": "/api/v3/groups/shop_list",
          "prames": {
            "group_guid": "shopgroup_system_all"
          },
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          }
        },
        {
          "model": "group",
          "id": "shopgroup_7b2c75b5f9534576a4c2b8fc327ff2b8",
          "name": "shop2",
          "type": "custom",
          "source": "/api/v3/groups/shop_list",
          "prames": {
            "group_guid": "shopgroup_7b2c75b5f9534576a4c2b8fc327ff2b8"
          },
          "marks": {
            "model": "tags",
            "tags": []
          }
        },
        {
          "model": "group",
          "id": "shopgroup_d1e158df3ef94008a89481edcd1da371",
          "name": "shop1",
          "type": "custom",
          "source": "/api/v3/groups/shop_list",
          "prames": {
            "group_guid": "shopgroup_d1e158df3ef94008a89481edcd1da371"
          },
          "marks": {
            "model": "tags",
            "tags": []
          }
        },
        {
          "model": "group",
          "id": "shopgroup_3e4d7a9bff874e3fa3f4578ec9919fff",
          "name": "shop3",
          "type": "custom",
          "source": "/api/v3/groups/shop_list",
          "prames": {
            "group_guid": "shopgroup_3e4d7a9bff874e3fa3f4578ec9919fff"
          },
          "marks": {
            "model": "tags",
            "tags": []
          }
        }
      ],
      "total": 4
    };
    return [200, response];
  });
};
